<template>
  <div
    class="divProjectAdvantage"
    v-lazy:background-image="{
      src: bg,
    }"
  >
  <slot></slot>
    <div class="divContent">
      <div class="bigbox">
        <div class="imgs">
          <img v-lazy="{
            src:img,
            loading: require('./../../../../../assets/wheelplanting.jpg'),
            }" alt />
        </div>
        <div class="text">
          <p :style="{ backgroundImage: pBg }"></p>
          <div class="divDesc">
            <div v-for="(item, index) of desc" :key="index">
              {{ item + "。" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    desc: {
      type: Array,
      default: () => [],
    },
    bg: {
      type: String,
      default: "",
    },
    pBg: {
      type: String,
      default: "linear-gradient(to right, #496bcc, white)",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./../scss/projectAdvantageWidge.scss";
</style>
